import {
  IPlatformCommandHandler,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {take} from 'rxjs/operators';
import {PlatformCommand} from '@shared/commands/command-base';
import {CommandService} from '@core/services/command.service';
import {Router} from '@angular/router';
import {DialogService} from '@shared/services/dialog-service';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {DialogModel} from '@shared/models/dialog.model';
import {Injectable} from '@angular/core';
import {AuditTrackerCommandHandlerBase} from '@features/audit-tracker/services/command-handlers/audit-tracker-command-handler-base';

@Injectable({
  providedIn: 'root',
})
export class AddAuditTrackerCaseCommandHandler extends AuditTrackerCommandHandlerBase implements IPlatformCommandHandler {
  constructor( public commandService: CommandService,
               public router: Router,
               private dialogService: DialogService,
               public fuseSplashScreenService: FuseSplashScreenService,
               public snackBarService: SnackBarService ) {
    super(router, commandService, fuseSplashScreenService, snackBarService);
  }
  executeCommand(command: PlatformCommand, handler: IPlatformToolHandler, callback?: any): boolean {
    const dialogModel: DialogModel = DialogModel.create(
      'Add Case',
      'AddAuditRecordDialogComponent',
      {},
      '600px',
      '700px',
      true
    );
    this.dialogService.showOkCancelDialog(dialogModel).pipe(take(1)).subscribe(res => {
      if (res.action === 'OK') {
        console.log('OK button clicked!');
        // pars the values
        const entities = res.data.input['entity'];
        const auditType = res.data.input['auditType'];
        // const fiscalYears = res.data.input['fiscalYears'];
        const countries = res.data.input['countries'];
        const projectId = res.data.input['projectId'];
        // const states = res.data.input['states'];
        const title = res.data.input['title'];
        // const municipal = res.data.input['local'];
        // const otherJurisdiction = res.data.input['other'];
        const taxYearStart = res.data.input['taxYearStart'];
        const taxYearEnd = res.data.input['taxYearEnd'];

        command.fieldValues['EntityList'] = entities;
        command.fieldValues['AuditType'] = auditType.type;
        // command.fieldValues['FiscalYears'] = fiscalYears;
        command.fieldValues['CountryCodes'] = countries.map(country => country.code);
        command.fieldValues['ProjectId'] = projectId;
        command.fieldValues['Title'] = title;
        // command.fieldValues['LocalOrMunicipal'] = municipal;
        // command.fieldValues['OtherJurisdiction'] = otherJurisdiction;
        command.fieldValues['TaxYearStart'] = taxYearStart;
        command.fieldValues['TaxYearEnd'] = taxYearEnd;
        command.projectId = projectId;
        // if (states && states.length > 0) {
        //   command.fieldValues['CountryStates'] = states.map(state => state.id);
        // }
        this.executeCommandToApi(command, handler);
    }});
    return true;
  }
}
